import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { sprekersApi } from '../api';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  presentationId: string;
  onSaved?: () => void;
}

/** Mirrort TemplateFormDialog.tsx's eenvoud -- geen kleur/font-velden nodig,
 * dit is een herbruikbare preekstructuur, geen huisstijl. */
export default function CanvasSaveTemplateDialog({ open, onOpenChange, presentationId, onSaved }: Props) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) { setName(''); setDescription(''); }
  }, [open]);

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    try {
      await sprekersApi.createCanvasTemplate({ name, description: description || null, source_presentation_id: presentationId });
      toast.success('Sjabloon opgeslagen');
      onOpenChange(false);
      onSaved?.();
    } catch (error: any) {
      toast.error(error.response?.data?.detail || 'Opslaan mislukt');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Opslaan als sjabloon</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label htmlFor="template-name">Naam</Label>
            <Input id="template-name" value={name} onChange={(e: React.ChangeEvent<HTMLInputElement>) => setName(e.target.value)} required />
          </div>
          <div>
            <Label htmlFor="template-description">Omschrijving (optioneel)</Label>
            <Textarea
              id="template-description" rows={3} value={description}
              onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setDescription(e.target.value)}
            />
          </div>
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annuleren</Button>
            <Button type="submit" disabled={submitting || !name.trim()}>Opslaan</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
